export type CreateRecordAuditDefinitionApiResponse = /** status 201  */ {
  id: string;
};
export type CreateRecordAuditDefinitionApiArg = {
  body: CreateRecordAuditDefinitionRequestBody;
};
export type ListRecordAuditDefinitionApiResponse =
  /** status 200  */ RecordAuditDefinitionResponseBody[];
export type ListRecordAuditDefinitionApiArg = {
  resourceId?: string;
};
export type DeleteRecordAuditDefinitionApiResponse = unknown;
export type DeleteRecordAuditDefinitionApiArg = {
  definitionId: string;
};
export type GetRecordAuditDefinitionApiResponse =
  /** status 200  */ RecordAuditDefinitionResponseBody;
export type GetRecordAuditDefinitionApiArg = {
  definitionId: string;
};
export type UpdateRecordAuditDefinitionApiResponse = unknown;
export type UpdateRecordAuditDefinitionApiArg = {
  definitionId: string;
  body: UpdateRecordAuditDefinitionRequestBody;
};
export type RecordAuditDefinitionSectionRequestBody = {
  id: string;
  name: string;
};
export type RecordAuditDefinitionSectionResponseBody = {
  id: string;
  name: string;
};
export type RecordAuditCreateTaskDefinitionRequestBody = {
  isMandatory: boolean;
  fileRequired: boolean;
  description: string;
  weight?: number;
  sectionId?: string | null;
};
export type CreateRecordAuditDefinitionRequestBody = {
  name: string;
  description?: string | null;
  resourceId: string;
  tasks: RecordAuditCreateTaskDefinitionRequestBody[];
  category?: string | null;
  successThreshold?: number | null;
  sections?: RecordAuditDefinitionSectionRequestBody[];
};
export type RecordAuditTaskDefinitionResponseBody = {
  id: string;
  isMandatory: boolean;
  fileRequired: boolean;
  description: string;
  weight?: number;
  sectionId?: string | null;
};
export type RecordAuditDefinitionResponseBody = {
  id: string;
  name: string;
  description: string | null;
  resourceId: string;
  tasks: RecordAuditTaskDefinitionResponseBody[];
  category: string | null;
  successThreshold: number | null;
  sections: RecordAuditDefinitionSectionResponseBody[];
};
export type RecordAuditUpdateTaskDefinitionRequestBody = {
  isMandatory: boolean;
  fileRequired: boolean;
  description: string;
  id?: string | null;
  weight?: number;
  sectionId?: string | null;
};
export type UpdateRecordAuditDefinitionRequestBody = {
  resourceId: string;
  name: string;
  description?: string | null;
  tasks: RecordAuditUpdateTaskDefinitionRequestBody[];
  category?: string | null;
  successThreshold?: number | null;
  sections?: RecordAuditDefinitionSectionRequestBody[];
};
